import { Link } from "react-router-dom";
import { useMyPlayer } from "../../../context/MyPlayerContext";
import "./pk.css";

type Item = {
  label: string;
  count: number;
  // When set, the label links there.
  to?: string;
};

type Props = {
  items: Item[];
  color?: string;
  emptyText?: string;
};

// Ranked list where each row carries a bar scaled to the biggest count.
const RankedBars = ({
  items,
  color = "rgb(70, 130, 180)",
  emptyText = "Nothing yet."
}: Props) => {
  const { isMe } = useMyPlayer();
  if (items.length === 0) {
    return <div className="epic-lb-muted">{emptyText}</div>;
  }
  const max = Math.max(...items.map((i) => i.count), 1);
  return (
    <div>
      {items.map((item) => (
        <div key={item.label} className="pk-bar-row">
          <span className="pk-wrap-anywhere">
            {item.to ? (
              <Link
                className={isMe(item.label) ? "pk-link is-me" : "pk-link"}
                to={item.to}
              >
                {item.label}
              </Link>
            ) : (
              item.label
            )}
          </span>
          <span style={{ fontVariantNumeric: "tabular-nums" }}>
            {item.count}
          </span>
          <div className="pk-bar-track">
            <div
              className="pk-bar-fill"
              style={{
                width: `${Math.max((item.count / max) * 100, 2)}%`,
                backgroundColor: color
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default RankedBars;
